module.exports = __webpack_public_path__ + "img/thief_silver.cf1baede.svg";